@if (open) {
<app-modal
    class="profile-settings-modal"
    [title]="(activeSecurityModal() ? 'app.profileSettings.sections.securityAccount.title' : 'app.profileSettings.title') | translate"
    [subtitle]="(activeSecurityModal() ? 'app.profileSettings.securitySidebar.description' : 'app.profileSettings.subtitle') | translate"
    [closeButtonText]="'common.actions.close' | translate" [showFooter]="false"
    [width]="activeSecurityModal() ? 'min(100%, 1030px)' : 'min(100%, 850px)'"
    [minHeight]="activeSecurityModal() ? 'min(92vh, 690px)' : 'min(92vh, 700px)'"
    [maxHeight]="activeSecurityModal() ? 'min(92vh, 690px)' : 'min(92vh, 700px)'" (closed)="requestClose()">
    <div class="settings-modal" [class.settings-modal--security]="activeSecurityModal()">

        @if (loading()) {
        <div class="settings-modal__loading">{{ 'app.profileSettings.loading' | translate }}</div>
        } @else {
        <div class="settings-modal__body">
            <aside class="settings-sidebar" [attr.aria-label]="'app.profileSettings.nav.ariaLabel' | translate">
                @if (!activeSecurityModal()) {
                <div class="settings-sidebar__profile">
                    <div class="settings-sidebar__avatar">{{ getInitials() }}</div>
                    <div class="settings-sidebar__name">{{ getFullName() }}</div>
                    <div class="settings-sidebar__email">{{ getEmail() }}</div>
                </div>

                <nav class="settings-sidebar__nav" [attr.aria-label]="'app.profileSettings.nav.ariaLabel' | translate">
                    @for (item of navItems; track item.id) {
                    <button type="button" class="settings-sidebar__nav-item"
                        [class.settings-sidebar__nav-item--active]="activeSection() === item.id"
                        (mouseenter)="onNavItemMouseEnter(item.id)" (mouseleave)="onNavItemMouseLeave(item.id)"
                        (click)="scrollToSection(item.id)">
                        <app-icon class="settings-sidebar__nav-icon" [icon]="getSidebarNavIcon(item.id)"
                            [color]="getSidebarNavIconColor(item.id)" />
                        {{ item.labelKey | translate }}
                    </button>
                    }
                </nav>

                @if (!activeSecurityModal()) {
                <button type="button" class="settings-sidebar__save safegpt-button" [disabled]="submitting()"
                    (click)="onSaveOrClose()">
                    {{ getSaveButtonLabelKey() | translate }}
                </button>
                }
                } @else {
                <nav class="settings-sidebar__nav"
                    [attr.aria-label]="'app.profileSettings.sections.securityAccount.title' | translate">
                    <button type="button" class="settings-sidebar__nav-item"
                        [class.settings-sidebar__nav-item--active]="activeSecurityModal() === 'email'"
                        (mouseenter)="onSecurityNavItemMouseEnter('email')"
                        (mouseleave)="onSecurityNavItemMouseLeave('email')" (click)="openSecurityModal('email')">
                        <app-icon class="settings-sidebar__nav-icon" [icon]="getSecuritySidebarNavIcon('email')"
                            [color]="getSecuritySidebarNavIconColor('email')" />
                        <span>
                            <strong>{{ 'app.profileSettings.securityCards.email.title' | translate }}</strong>
                            <small>{{ 'app.profileSettings.securitySidebar.emailHint' | translate }}</small>
                        </span>
                    </button>

                    <button type="button" class="settings-sidebar__nav-item"
                        [class.settings-sidebar__nav-item--active]="activeSecurityModal() === 'password'"
                        (mouseenter)="onSecurityNavItemMouseEnter('password')"
                        (mouseleave)="onSecurityNavItemMouseLeave('password')" (click)="openSecurityModal('password')">
                        <app-icon class="settings-sidebar__nav-icon" [icon]="getSecuritySidebarNavIcon('password')"
                            [color]="getSecuritySidebarNavIconColor('password')" />
                        <span>
                            <strong>{{ 'app.profileSettings.securityCards.password.title' | translate }}</strong>
                            <small>{{ 'app.profileSettings.securitySidebar.passwordHint' | translate }}</small>
                        </span>
                    </button>

                    @if (canShowMfaOption()) {
                    <button type="button" class="settings-sidebar__nav-item"
                        [class.settings-sidebar__nav-item--active]="activeSecurityModal() === 'mfa'"
                        (mouseenter)="onSecurityNavItemMouseEnter('mfa')"
                        (mouseleave)="onSecurityNavItemMouseLeave('mfa')" (click)="openSecurityModal('mfa')">
                        <app-icon class="settings-sidebar__nav-icon" [icon]="getSecuritySidebarNavIcon('mfa')"
                            [color]="getSecuritySidebarNavIconColor('mfa')" />
                        <span>
                            <strong>2FA</strong>
                            <small>{{ 'app.profileSettings.securitySidebar.mfaHint' | translate }}</small>
                        </span>
                    </button>
                    }

                    @if (canManageApiTokens()) {
                    <button type="button" class="settings-sidebar__nav-item"
                        [class.settings-sidebar__nav-item--active]="activeSecurityModal() === 'tokens'"
                        (mouseenter)="onSecurityNavItemMouseEnter('tokens')"
                        (mouseleave)="onSecurityNavItemMouseLeave('tokens')" (click)="openSecurityModal('tokens')">
                        <app-icon class="settings-sidebar__nav-icon" [icon]="getSecuritySidebarNavIcon('tokens')"
                            [color]="getSecuritySidebarNavIconColor('tokens')" />
                        <span>
                            <strong>{{ 'app.profileSettings.securityCards.tokens.title' | translate }}</strong>
                            <small>{{ 'app.profileSettings.securitySidebar.tokensHint' | translate }}</small>
                        </span>
                    </button>
                    }
                </nav>

                <div class="settings-sidebar__tip-card">
                    <span class="settings-sidebar__tip-icon">
                        <app-icon icon="icon-shield-regular.svg" color="currentColor" />
                    </span>
                    <strong>{{ 'app.profileSettings.securitySidebar.tipTitle' | translate }}</strong>
                    <p>{{ 'app.profileSettings.securitySidebar.tipBody' | translate }}</p>
                    <a href="https://support.safegpt.nl" target="_blank" rel="noreferrer">
                        {{ 'app.profileSettings.securitySidebar.tipLink' | translate }}
                    </a>
                </div>
                }
            </aside>

            <section class="settings-content" #contentContainer (scroll)="onContentScroll()">
                @if (!activeSecurityModal()) {
                <div class="settings-section" id="personal-data">
                    <h3><app-icon icon="icon-mode-portrait-regular.svg" color="currentColor" />
                        {{ 'app.profileSettings.sections.personalData.title' | translate }}</h3>

                    <div class="field">
                        <label for="firstName">{{ 'app.profileSettings.personalData.firstName' | translate }}</label>
                        <input id="firstName" name="firstName" type="text" [(ngModel)]="profileModel.firstName"
                            [placeholder]="'app.profileSettings.personalData.firstNamePlaceholder' | translate" />
                    </div>

                    <div class="field-row">
                        <div class="field field--small">
                            <label for="middleName">{{ 'app.profileSettings.personalData.middleName' | translate
                                }}</label>
                            <input id="middleName" name="middleName" type="text" [(ngModel)]="profileModel.middleName"
                                [placeholder]="'app.profileSettings.personalData.middleNamePlaceholder' | translate" />
                        </div>
                        <div class="field">
                            <label for="lastName">{{ 'app.profileSettings.personalData.lastName' | translate }}</label>
                            <input id="lastName" name="lastName" type="text" [(ngModel)]="profileModel.lastName"
                                [placeholder]="'app.profileSettings.personalData.lastNamePlaceholder' | translate" />
                        </div>
                    </div>

                    <div class="field-row">
                        <div class="field field--small">
                            <label for="countryCode">{{ 'app.profileSettings.personalData.countryCode' | translate
                                }}</label>
                            <app-dropdown labelForId="countryCode" [items]="countries" bindLabel="dialingCode"
                                bindValue="countryCode" [dropdownMenuWidth]="'250px'" [searchFn]="countrySearchFn"
                                [clearable]="false" [searchable]="true" [ngModel]="profileModel.countryCode"
                                (ngModelChange)="profileModel.countryCode = $event"
                                [templateLabel]="dialCountryLabelTemplate" [templateOption]="dialCountryOptionTemplate"
                                [labelFontSize]="12">
                            </app-dropdown>
                        </div>
                        <div class="field">
                            <label for="phoneNumber">{{ 'app.profileSettings.personalData.phoneNumber' | translate
                                }}</label>
                            <input id="phoneNumber" name="phoneNumber" type="text"
                                [(ngModel)]="profileModel.phoneNumberLocal"
                                [placeholder]="'app.profileSettings.personalData.phoneNumberPlaceholder' | translate" />
                        </div>
                    </div>
                </div>

                <hr class="horizontal color-300">

                <div class="settings-section" id="accessibility">
                    <h3><app-icon icon="icon-interlining-regular.svg" color="currentColor" />
                        {{ 'app.profileSettings.sections.accessibility.title' | translate }}</h3>

                    <label class="settings-toggle" for="dyslexiaModeEnabled">
                        <span class="settings-toggle__text">
                            <strong>{{ 'app.profileSettings.accessibility.dyslexiaMode' | translate }}</strong>
                            <small>{{ 'app.profileSettings.accessibility.dyslexiaModeHelp' | translate }}</small>
                        </span>
                        <input id="dyslexiaModeEnabled" name="dyslexiaModeEnabled" type="checkbox"
                            [(ngModel)]="profileModel.dyslexiaModeEnabled" />
                        <span class="settings-toggle__control" aria-hidden="true"></span>
                    </label>
                </div>

                <hr class="horizontal color-300">

                <div class="settings-section" id="security-account">
                    <h3><app-icon icon="icon-lock-regular.svg" color="currentColor" />
                        {{ 'app.profileSettings.sections.securityAccount.title' | translate }}</h3>

                    <div class="security-grid">
                        <button type="button" class="security-card" (click)="openSecurityModal('email')">
                            <div class="security-card__head">
                                <app-icon icon="icon-mail-regular.svg" color="currentColor" />
                                <span>{{ 'app.profileSettings.securityCards.email.title' | translate }}</span>
                            </div>
                            <span>{{ 'app.profileSettings.securityCards.email.description' | translate }}</span>
                            <app-icon class="security-card__arrow" icon="icon-arrow-right-solid.svg" color="currentColor" />
                        </button>

                        <button type="button" class="security-card" (click)="openSecurityModal('password')">
                            <div class="security-card__head">
                                <app-icon icon="icon-lock-regular.svg" color="currentColor" />
                                <span>{{ 'app.profileSettings.securityCards.password.title' | translate }}</span>
                            </div>
                            <span>{{ 'app.profileSettings.securityCards.password.description' | translate }}</span>
                            <app-icon class="security-card__arrow" icon="icon-arrow-right-solid.svg" color="currentColor" />
                        </button>

                        @if (canShowMfaOption()) {
                        <button type="button" class="security-card" (click)="openSecurityModal('mfa')">
                            <div class="security-card__head">
                                <app-icon icon="icon-mode-portrait-regular.svg" color="currentColor" />
                                <span>{{ 'app.profileSettings.securityCards.mfa.title' | translate }}</span>
                            </div>
                            <span>{{ 'app.profileSettings.securityCards.mfa.description' | translate }}</span>
                            <app-icon class="security-card__arrow" icon="icon-arrow-right-solid.svg" color="currentColor" />
                        </button>
                        }

                        @if (canManageApiTokens()) {
                        <button type="button" class="security-card" (click)="openSecurityModal('tokens')">
                            <div class="security-card__head">
                                <app-icon icon="icon-key-regular.svg" color="currentColor" />
                                <span>{{ 'app.profileSettings.securityCards.tokens.title' | translate }}</span>
                            </div>
                            <span>{{ 'app.profileSettings.securityCards.tokens.description' | translate }}</span>
                            <app-icon class="security-card__arrow" icon="icon-arrow-right-solid.svg" color="currentColor" />
                        </button>
                        }
                    </div>
                </div>

                <hr class="horizontal color-300">

                <div class="settings-section" id="active-sessions">
                    <div class="sessions-header">
                        <h3><app-icon icon="icon-shield-regular.svg" color="currentColor" />
                            {{ 'app.profileSettings.sections.activeSessions.title' | translate }}</h3>
                        <app-button-small class="sessions-header__revoke-button" buttonType="border"
                            preIcon="icon-trash-regular.svg" iconColor="currentColor" [iconWidth]="15" [iconHeight]="15"
                            (pressed)="revokeOtherSessions()">
                            {{ 'app.profileSettings.sections.activeSessions.revokeOthers' | translate }}
                        </app-button-small>
                    </div>

                    <div class="session-list">
                        @for (session of sessions; track session.sessionId) {
                        <div class="session-item">
                            <div class="session-item__title">
                                <div class="session-item__name">
                                    @if (session.isCurrentSession) {
                                    {{ 'app.profileSettings.sections.activeSessions.currentSession' | translate }}
                                    } @else {
                                    {{ 'app.profileSettings.sections.activeSessions.webSession' | translate }}
                                    }
                                </div>
                                <div class="session-item__meta">
                                    {{ 'app.profileSettings.sections.activeSessions.lastActive' | translate }}:
                                    {{ session.lastUsedAt | date:'dd-MM-yyyy' }}
                                    {{ 'app.profileSettings.sections.activeSessions.at' | translate }}
                                    {{ session.lastUsedAt | date: 'HH:mm' }} UTC
                                </div>
                            </div>
                            <div>
                                @if (session.isCurrentSession) {
                                <span class="current-badge">{{ 'app.profileSettings.sections.activeSessions.activeNow' |
                                    translate }}</span>
                                } @else {
                                <app-button-small class="session-item__revoke-button" buttonType="border"
                                    preIcon="icon-trash-regular.svg" [iconWidth]="15"
                                    [iconHeight]="15"
                                    [ariaLabel]="'app.profileSettings.sections.activeSessions.logout' | translate"
                                    (pressed)="revokeSession(session.sessionId)" />
                                }
                            </div>
                        </div>
                        }
                        @if (hasMoreSessions()) {
                        <button type="button" class="session-list__more" [disabled]="sessionsLoadingMore()"
                            (click)="loadMoreSessions()">
                            {{ 'app.profileSettings.sections.activeSessions.more' | translate: { count:
                            remainingSessionCount() } }}
                        </button>
                        }
                    </div>
                </div>
                } @else {
                <div class="security-inline-panel">
                    @if (activeSecurityModal() === 'email') {
                    <app-change-email [model]="securityEmailModel" [currentEmail]="getEmail()"
                        (update)="updateEmailAddress()" (cancelled)="closeSecurityModal()" />
                    }

                    @if (activeSecurityModal() === 'password') {
                    <app-change-password [model]="passwordModel" (save)="updatePassword()"
                        (cancelled)="closeSecurityModal()" />
                    }

                    @if (activeSecurityModal() === 'mfa') {
                    <app-setup-mfa [mfaSetup]="mfaSetup" [mfaQrCodeDataUrl]="mfaQrCodeDataUrl" [mfaCode]="mfaCode"
                        [mfaWizardStep]="mfaWizardStep()" [mfaBusy]="mfaBusy()" [canEnableMfa]="canEnableMfa()"
                        [canDisableMfa]="canDisableMfa()" (mfaCodeChange)="mfaCode = $event"
                        (startSetup)="startMfaEnrollment()" (activate)="completeMfaEnrollment()"
                        (disable)="disableMfa()" (cancelled)="closeSecurityModal()" />
                    }

                    @if (activeSecurityModal() === 'tokens' && canManageApiTokens()) {
                    <app-api-token [tokenCreateModel]="tokenCreateModel" [generatedTokenValue]="generatedTokenValue"
                        [apiTokens]="apiTokens" (createToken)="createApiToken()" (rotateToken)="rotateApiToken($event)"
                        (deleteToken)="deleteApiToken($event)" (cancelled)="closeSecurityModal()" />
                    }
                </div>
                }
            </section>
        </div>
        }
    </div>

    <app-confirm-modal [open]="showDiscardChangesConfirm()" [message]="'app.profileSettings.discardChanges.message'"
        [confirmLabel]="'common.actions.confirm'" [cancelLabel]="'app.confirmModal.cancel'"
        (confirmed)="confirmDiscardChanges()" (cancelled)="cancelDiscardChanges()" />

</app-modal>
}

